import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class DocumentList extends Component {
  componentWillMount() {
    this.props.setHeader({
      title: "ドキュメント一覧",
      left: null,
      right: {
        text: 'edit',
        url: "/document/edit/document",
        admin: true
      }
    })
  }
  render() {
    const { documents } = this.props
    return (
      documents.document?
        <div>
          <div className="text" dangerouslySetInnerHTML={{__html: documents.document.text}}></div>
        </div>
      :
        <div>
          {Object.keys(documents).map(docId => {
            return (
              <Link to={'/document/' + docId} key={docId} className="doc">{documents[docId].title}</Link>
            )
          })}
        </div>
    )
  }
}

export default DocumentList


// WEBPACK FOOTER //
// ./src/components/DocumentList.js